import { ColorConvertor } from "../../utility/functions";

const Chip = ({ children, color, opacity = 10, ...rest }) => {
  const hasColor = Boolean(color);
  const bgOpacity = opacity / 100;
  const rgb = hasColor ? ColorConvertor(color) : null;
  return (
    <span
      {...rest}
      style={hasColor ? {
        backgroundColor: `rgba(${rgb},${bgOpacity})`,
        color: color,
      } : {
        backgroundColor: "transparent",
        color: "inherit",
      }}>
      {children}
    </span>
  );
};

export default Chip;
